<template>
    <div>
        <el-page-header @back="goBack" content="监测链接地址生成"></el-page-header>
        <h1>
            <el-card class="form-container" shadow="never">
                <el-form :inline="true" :model="data" size="small" label-width="140px">
                    <el-form-item label="app应用：">
                        <el-select v-model="data.package" placeholder="请选择" filterable>
                            <el-option
                                v-for="item in this.enum"
                                :key="item.appId"
                                :label="item.appName"
                                :value="item.packageName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-card>
        </h1>
        <el-card>
            <div slot="header"><h2>巨量监测链接地址</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&mid1=__MID1__&ts=__TS__&mid3=__MID3__&mid5=__MID5__&mac=__MAC__&aidName=__AID_NAME__&advertiserId=__ADVERTISER_ID__&projectName=__PROJECT_NAME__&callbackParam=__CALLBACK_PARAM__&csite=__CSITE__&requestId=__REQUEST_ID__&promotionId=__PROMOTION_ID__&ctype=__CTYPE__&sl=__SL__&ipv4=__IPV4__&idfa=__IDFA__&ipv6=__IPV6__&model=__MODEL__&ua=__UA__&mac1=__MAC1__&trackId=__TRACK_ID__&idfaMd5=__IDFA_MD5__&cid=__CID__&mid2=__MID2__&mid4=__MID4__&mid6=__MID6__&convertId=__CONVERT_ID__&oaidMd5=__OAID_MD5__&cidName=__CID_NAME__&unionSite=__UNION_SITE__&os=__OS__&aid=__AID__&ip=__IP__&androidid=__ANDROIDID__&geo=__GEO__&imei=__IMEI__&oaid=__OAID__&promotionName=__PROMOTION_NAME__&projectId=__PROJECT_ID__&platform=juliang_engine&campaignId=__CAMPAIGN_ID__&caid=__CAID__&campaignName=__CAMPAIGN_NAME__&callbackUrl=__CALLBACK_URL__
            </h4>
        </el-card>

        <el-card>
            <div slot="header"><h2>磁力监测链接地址</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&cid=__CID__&advertiserId=__ACCOUNTID__&campaignName=__DNAME__&ts=__TS__&idfaMd5=__IDFA2__&imei=__IMEI2__&ipv4=__IPV4__&ipv6=__IPV6__&oaid=__OAID__&model=__MODEL__&callbackUrl=__CALLBACK__&platform=cili_engine&csite=__CSITE__&ua=__UA__&campaignId=__DID__&mac1=__MAC2__&oaidMd5=__OAID2__&os=__OS__&mac=__MAC3__&androidid=__ANDROIDID2__&aid=__AID__&ip=__IP__&trackId=__LLSID__
            </h4>
        </el-card>

        <el-card>
            <div slot="header"><h2>百度监测链接地址（必须手动配置关键行为配置）</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=baidu_dev2&cid=__IDEA_ID__&aid=__PLAN_ID__&campaignId=__UNIT_ID__&advertiserId=__USER_ID__&idfa=__IDFA__&imei=__IMEI__&androidid=__ANDROIDID__&ip=__IP__&ua=__UA__&os=__OS__&ts=__TS__&mac=__MAC__&mac1=__MAC1__&oaid=__OAID__&oaidMd5=__OAID_MD5__&callbackUrl=__CALLBACK_URL__&trackId=__CLICK_ID__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>广点通监测链接地址</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=gdt_tx&cid=__DYNAMIC_CREATIVE_ID__&aid=__ADGROUP_ID__&advertiserId=__ACCOUNT_ID__&idfaMd5=__MUID__&imei=__MUID__&androidid=__HASH_ANDROID_ID__&ip=__IP__&ua=__USER_AGENT__&os=__DEVICE_OS_TYPE__&ts=__CLICK_TIME__&oaidMd5=__HASH_OAID__&callbackUrl=__CALLBACK__&trackId=__CLICK_ID__&caid=__QAID_CAA__&yyid=__PROMOTED_OBJECT_ID__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>华为商店监测链接地址</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=shop_huawei&aid=__AID__&aidName=__AID_NAME__&advertiserId=__APP_ID__&appName=__APP_NAME__&channelName=__CHANNEL_NAME__&channelId=__CHANNEL_ID__&groupName=__GROUP_NAME__&groupId=__GROUP_ID__&oaid=__OAID__&idType=__ID_TYPE__&trackId=__UNIQUE_ID__&actionType=__ACTION_TYPE__&ts=__TS__&callbackParam=__CALLBACK__&cid=__SUB_TASKID__&rtaid=__RTAID__&groupLevel=__GROUP_LEVEL__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>小米商店监测链接地址3.0</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=shop_xiaomi&aid=__ADID__&aidName=__ADNAME__&advertiserId=__CUSTOMERID__&appId=__APPID__&responseValidate=false&expId=__EXPID__&rtaExpId=__RTAEXPID__&oaid=__OAID__&imei=__IMEI__&imei2=__IMEI2__&androidid=__ANDROIDID__&ip=__IP__&ua=__UA__&ts=__TS__&callbackParam=__CALLBACK__&cid=__CAMPAIGNID__&response_validate=false&idfa=3&sign=__SIGN__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>小米商店监测链接地址4.0（必须手动配置关键行为配置）</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=shop_xiaomi&aid=__ADREPORTID__&aidName=__ADNAME__&advertiserId=__CUSTOMERID__&appId=__APPID__&responseValidate=false&expId=__EXPID__&rtaExpId=__RTAEXPID__&oaid=__OAID__&imei=__IMEI__&imei2=__IMEI2__&androidid=__ANDROIDID__&ip=__IP__&ua=__UA__&ts=__TS__&callbackParam=__CALLBACK__&cid=__CAMPAIGNID__&response_validate=false&idfa=4&sign=__SIGN__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>小红书</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=xhs&oaidMd5=__OAID__&idfaMd5=__IDFA_MD5__&androidid=__ANDROIDID__&os=__OS__&ip=__IP__&ts=__TS__&ua=__UA1__&trackId=__CLICK_ID__&advertiserId=__ADVERTISER_ID__&aid=__UNIT_ID__&campaignId=__CAMPAIGN_ID__&cid=__CREATIVITY_ID__&caid=__CAID__&caidMd5=__CAID_MD5__&imei=__IMEI__&paid=__PAID__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>荣耀</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=shop_honor&oaid=__OAID__&os=__OS__&ip=__IP__&trackId=__TRACK_ID__&advertiserId=__ADVERTISER_ID__&cid=__CREATIVE_ID__&ts=__TIME__&ua=__UA__&campaignId=__CAMPAIGNID__&aid=__GROUPID__
            </h4>
        </el-card>
        <el-card>
            <div slot="header"><h2>oppo</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback?packageName=<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=shop_oppo&oaid=__OAID__&androidid=__ANDROIDID__&imei=$im$&os=$os$&ua=$ua$&aid=$groupid$&advertiserId=$ownerid$&cid=$ad$&campaignId=$planid$&ip=__IP__&ts=__TS__
            </h4>
        </el-card>
      <el-card>
        <div slot="header"><h2>华夏</h2></div>
        <h4>https://gs.gateway.gameley.cn/gs-attribution/huaxia/callback?packageName=<span
          style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>&platform=hua_xia&oaid=__OAID__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ua=__UA__&advertiserId=__ACCOUNT_ID__&cid=__CREATIVE_ID__&campaignId=__CAMPAIGN_ID__&ip=__IP__&ts=__TS__&callbackUrl=__CALLBACK_URL__&trackId=__CLICK_ID__&oaidMd5=__OAID_MD5__

        </h4>
      </el-card>
        <el-card>
            <div slot="header"><h2>vivo</h2></div>
            <h4>https://gs.gateway.gameley.cn/gs-attribution/juliang/callback/vivo/<span
                style="color:red">{{ this.data.package === "" ? "请选择包" : this.data.package }}</span>/shop_vivo</h4>
        </el-card>
    </div>
</template>

<script>
import {appAll} from '@/http/api'

export default {
    name: "WatchLinkedUrl",
    data() {
        return {
            data: {
                package: ''
            },
            enum: []
        }
    },
    methods: {
        goBack() {
            this.$router.push({path: '/attributionRule'});
        },

    },
    created() {
        appAll().then(resp => {
            this.enum = resp.data.info;
        });
    }
}
</script>

<style scoped>

</style>